import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectBasketcustomerGroup: "selectBasketcustomerGroup [Action]",
  selectBasketcustomerGroupLoading: "selectBasketcustomerGroupLoading [Action]",
  selectBasketcustomerGroupAsync: "selectBasketcustomerGroupAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_basketcustomer_group = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectBasketcustomerGroup:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectBasketcustomerGroupLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectBasketcustomerGroupLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_basketcustomer_group",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectBasketcustomerGroup,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectBasketcustomerGroupLoading,
      payload: false,
    });
  }
}

export function* selectBasketcustomerGroup() {
  yield takeLatest(actionTypes.selectBasketcustomerGroupAsync, handleWorker);
}
